import React from 'react';

import {
  Breadcrumbs,
  BusinessContactForm,
  BusinessTariffsCard,
  InternetBanner,
  Tab,
  TabContent,
  TabContentItem,
  TabPanel,
  Tabs,
  TextBlock,
} from '@/ui/index';

import { Questions } from '../../roaming';

import styles from '../Bundles/Bundles.module.scss';

const Archive = ({ data }) => {
  const [activeTab, setActiveTab] = React.useState(0);
  return (
    <>
      {data?.breadcrumbs && <Breadcrumbs data={data.breadcrumbs} dark />}
      {data?.mainBanner && (
        <InternetBanner bannerData={data.mainBanner} dark medium />
      )}
      <Tabs active={activeTab}>
        <TabPanel className={'wrapper'}>
          <Tab onClick={() => setActiveTab(0)}>Roaming Internet packages</Tab>
          <Tab onClick={() => setActiveTab(1)}>All-in-one</Tab>
          <Tab onClick={() => setActiveTab(2)}>Сalls</Tab>
        </TabPanel>
        <TabContent>
          <TabContentItem>
            <div className={'wrapper'}>
              <TextBlock className={styles.text}>
                Choose All-in-One bundles in roaming for your trips to feel the
                superior benefit of boundless communication!
              </TextBlock>
            </div>
            {data?.offers && <BusinessTariffsCard data={data.offers} />}
          </TabContentItem>
          <TabContentItem>
            <div className={'wrapper'}>
              <TextBlock className={styles.text}>
                Choose All-in-One bundles in roaming for your trips to feel the
                superior benefit of boundless communication!
              </TextBlock>
            </div>
            {data?.offers && <BusinessTariffsCard data={data.offers} />}
          </TabContentItem>
          <TabContentItem>
            <div className={'wrapper'}>
              <TextBlock className={styles.text}>
                Choose All-in-One bundles in roaming for your trips to feel the
                superior benefit of boundless communication!
              </TextBlock>
            </div>
            {data?.offers && <BusinessTariffsCard data={data.offers} />}
          </TabContentItem>
        </TabContent>
      </Tabs>
      {data?.questions && (
        <Questions
          title={null}
          className={'wrapper section'}
          questions={data.questions}
        />
      )}
      {data?.banner && <BusinessContactForm bannerData={data?.banner} />}
    </>
  );
};

export default Archive;
